export const videoUrl = "https://assets.corneliuses.com/videos/iSeatz";
export const thumbnailUrl = "https://assets.corneliuses.com/photos/iSeatz/video-thumbnails";
export const photoUrl = "https://assets.corneliuses.com/photos/iSeatz";
export const corneliusesLinks = [{
    title: 'Corneliuses Home',
    url: 'http://corneliuses.com'
}, {
    title: 'My Homepage',
    url: 'https://brian.corneliuses.com'
}];